module.exports = __webpack_public_path__ + "static/media/RP-B_S_Jacquard_City Life_Bordeaux_PW Pink.2b571cfe.png";